import { createSelector } from "reselect";
import { AppState } from "../rootReducer";


// POST Data Loader

const postDataPending = (state: AppState) => state.postDataLoader.pending;
const postDataLoader = (state: AppState) => state.postDataLoader.dataLoader;
const postDataError = (state: AppState) => state.postDataLoader.error;

export const postDataPendingSelector = createSelector(postDataPending, (pending) => pending);
export const postDataSelector = createSelector(postDataLoader, (dataLoader) => dataLoader);
export const postDataErrorSelector = createSelector(postDataError, (error) => error);


// PUT Data Loader

const putDataPending = (state: AppState) => state.putDataLoader.pending;
const putDataLoader = (state: AppState) => state.putDataLoader.dataLoader;
const putDataError = (state: AppState) => state.putDataLoader.error;

export const putDataPendingSelector = createSelector(putDataPending, (pending) => pending);
export const putDataSelector = createSelector(putDataLoader, (dataLoader) => dataLoader);
export const putDataErrorSelector = createSelector(putDataError, (error) => error);


// GET Data Loader list 

const getLoadersListPending = (state: AppState) => state.loaders.pending;
const getLoadersList = (state: AppState) => state.loaders.loaders;
const getLoadersListError = (state: AppState) => state.loaders.error;

export const getLoadersListSelector = createSelector(getLoadersList, (loaders) => loaders);
export const getLoadersListPendingSelector = createSelector(getLoadersListPending,(pending) => pending);
export const getLoadersListErrorSelector = createSelector(getLoadersListError, (error) => error);

// GET Data Loader

const getLoaderDetailsPending = (state: AppState) => state.loaderDetails.pending;
const getLoaderDetails = (state: AppState) => state.loaderDetails.loaderDetails;
const getLoaderDetailsError = (state: AppState) => state.loaderDetails.error;

export const getLoaderSelector = createSelector(getLoaderDetails, (loaderDetails) => loaderDetails);
export const getLoaderPendingSelector = createSelector(getLoaderDetailsPending,(pending) => pending);
export const getLoaderErrorSelector = createSelector(getLoaderDetailsError, (error) => error);

// DELETE Data Loader

const deleteLoaderPending = (state: AppState) => state.deleteDataLoader.pending;
const deleteLoader = (state: AppState) => state.deleteDataLoader.deleteStatus;
const deleteLoaderError = (state: AppState) => state.deleteDataLoader.error;

export const deleteLoaderSelector = createSelector(deleteLoader, (loader) => loader);
export const deleteLoaderPendingSelector = createSelector(deleteLoaderPending,(pending) => pending);
export const deleteLoaderErrorSelector = createSelector(deleteLoaderError, (error) => error);

// extractor details
const getLoaderStatusPending = (state: AppState) => state.loaderStatus.pending;
const getLoaderStatus = (state: AppState) => state.loaderStatus.loaderStatus;
const getLoaderStatusError = (state: AppState) => state.loaderStatus.error;

export const getLoaderStatusSelector = createSelector(getLoaderStatus, (loaderStatus) => loaderStatus);
export const getLoaderStatusPendingSelector = createSelector(getLoaderStatusPending,(pending) => pending);
export const getLoaderStatusErrorSelector = createSelector(getLoaderStatusError, (error) => error);
